export default function Spinner() {
  return (
    <div className="min-h-80 flex items-center flex-col justify-center">
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
    </div>
  );
}
